import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "file-addition",
  "use": "file-addition-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"file-addition\"><title>icn/file-additions</title><path d=\"M7 7V5a1 1 0 1 1 2 0v2h2a1 1 0 0 1 0 2H9v2a1 1 0 0 1-2 0V9H5a1 1 0 1 1 0-2h2zM4.25 2h7.5A2.25 2.25 0 0 1 14 4.25v7.5A2.25 2.25 0 0 1 11.75 14h-7.5A2.25 2.25 0 0 1 2 11.75v-7.5A2.25 2.25 0 0 1 4.25 2zm.179 1C3.639 3 3 3.64 3 4.429v7.142C3 12.361 3.64 13 4.429 13h7.142c.79 0 1.429-.64 1.429-1.429V4.43C13 3.639 12.36 3 11.571 3H4.43z\" id=\"file-addition_a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol